import type { Feature } from '@luna/gatekeeper';

export const cardServices: Feature = {
    enabled: false,
    _description: 'Displays additional card services in the credit card settings page',
};
